import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { forkJoin } from 'rxjs';
import { SignupService } from '../signup.service';
import { BusinessNameFormGroup, providerFormGroup } from './providerForm.interface';
import { HttpErrorResponse } from '@angular/common/http';
import { CountryData } from '../../../interfaces/country.interface';
import { HomeService } from '../../home.service';
import { DestinationData } from '../../../../app/interfaces/destination.interface';
import { CityData } from '../../../../app/interfaces/city.interface';
import { ClientSetting } from '../../../../app/interfaces/clientSetting.interface';
import { NotificationService } from '../../../shared/notifications/notification.service';
import { TurnstileComponent } from '../../../shared/turnstile/turnstile.component';
import { setting } from '../../../../../setting';
import { HeroVariant } from '../../hero/hero.component';

@Component({
	selector: 'providers-form',
	templateUrl: './providers.component.html',
	styleUrls: ['./providers.component.scss'],
	providers: [SignupService]
})

export class ProviderComponent implements OnInit {
  @ViewChild('openModalErrorJoinUs') openModalErrorJoinUs!: ElementRef;
  @ViewChild('closeButtonModalErrorSignup') closeButtonModalErrorSignup!: ElementRef;
  @ViewChild(TurnstileComponent) turnstile?: TurnstileComponent;
  @Input() sharedData: any;
  @Input() getClientsSettingAppAuth!: ClientSetting;
  @Input() countries!: CountryData[];
  @Input() variant: HeroVariant = 'classic';

  @Output() dataEvent = new EventEmitter<{}>();
  @Output() successEvent = new EventEmitter<void>();
  @Output() errorEvent = new EventEmitter<void>();


	public load : boolean = false;
	public form!: FormGroup;
  public destinationsByIndex: { [key: number]: DestinationData[] } = {};
  public citiesByIndex: { [key: number]: CityData[] } = {};
  public categories: any[] = [];
  public providerForm!: providerFormGroup;
  public buttonError: boolean = false;

  private country_id: string = '';
  private countryName: string = '';

  public turnstileEnabled = setting.turnstileEnabled;
  public turnstileSiteKey = setting.turnstileSiteKey;
  public turnstileToken: string | null = null;
  private turnstileResolve: ((token: string) => void) | null = null;
  private turnstileReject: ((error: unknown) => void) | null = null;

	constructor(
		  private _signupService: SignupService,
    	private fb : FormBuilder,
      private _homeService: HomeService,
      public notificationService: NotificationService
	){}


  ngOnInit(): void {
    this.getCategories();
    this.initForm();
  }


  private initForm(): void {
    this.providerForm = this.fb.group({
      Youaretype: this.fb.nonNullable.control(2),
      client_id: this.fb.nonNullable.control(this.getClientsSettingAppAuth?.id),
      Name: this.fb.nonNullable.control('', [
        Validators.required, Validators.minLength(2), Validators.maxLength(50)
      ]),
      Email: this.fb.nonNullable.control('', [
        Validators.required, Validators.email
      ]),
      Address: this.fb.nonNullable.control('', [
        Validators.required, Validators.minLength(5), Validators.maxLength(100)
      ]),
      PhoneCode: this.fb.nonNullable.control('', [
        Validators.required
      ]),
      PhoneNumber: this.fb.nonNullable.control('', [
        Validators.required
      ]),
      country_name: this.fb.nonNullable.control(''),
      Country: this.fb.nonNullable.control(''),
      City: this.fb.nonNullable.control(''),
      city_name: this.fb.nonNullable.control(''),
      legal_entity_template: this.fb.control(''),
      Contact: this.fb.nonNullable.control('', [
        Validators.required
      ]),
      type_provider: this.fb.nonNullable.control('', [
        Validators.required
      ]),
      ContactLastName: this.fb.nonNullable.control('', [
        Validators.required
      ]),
      EmailContact: this.fb.nonNullable.control('', [
        Validators.required, Validators.email
      ]),
      PhoneCodeContact: this.fb.nonNullable.control('', [
        Validators.required
      ]),
      PhoneNumberContact: this.fb.nonNullable.control('', [
        Validators.required
      ]),
      Comments: this.fb.nonNullable.control('', [
        Validators.minLength(2), Validators.maxLength(200)
      ]),
      legal_entities: this.fb.array<BusinessNameFormGroup>([
        this.createBusinessNameForm()
      ])
    }) as unknown as providerFormGroup;
  }

  private createBusinessNameForm(): BusinessNameFormGroup {
    return this.fb.group({
      name: ['', Validators.required],
      tax_document_number: ['', Validators.required],
      legal_address: ['', Validators.required],
      country_id: ['', Validators.required],
      state_id: [null, Validators.required],
      city_id: [null, Validators.required],
      category_ids: [[], Validators.required]
    }) as unknown as BusinessNameFormGroup;
  }

    getDestinations(countryId: string, index: number): void {
      // ✅ Crear el array si no existe
      if (!this.destinationsByIndex[index]) {
        this.destinationsByIndex[index] = [];
      }
      if (!this.citiesByIndex[index]) {
        this.citiesByIndex[index] = [];
      }

      if (!countryId) {
        this.destinationsByIndex[index] = [];
        this.citiesByIndex[index] = [];
        return;
      }

      // ✅ Limpiar ciudad seleccionada al cambiar país
      const business = this.bussinessNames.at(index) as FormGroup;
      business?.get('city_id')?.setValue(null);

      if(index === 0) {
        const countrySelected = this.countries.find(c => c.country_code === countryId);

        if(!countrySelected) {
          console.warn('No se encontró el país');
          return;
        }

        this.providerForm.get('Country')?.setValue(countrySelected.country_code || '');
        this.providerForm.get('country_name')?.setValue(countrySelected.country_name);

      }

      this._homeService.getDestinationsData(countryId).subscribe({
        next: (res: DestinationData[]) => {
          if (res && Array.isArray(res) && res.length > 0) {
            // ✅ Guardar destinos por índice
            this.destinationsByIndex[index] = res;
            // ✅ Limpiar ciudades anteriores
            this.citiesByIndex[index] = [];
          } else {
            this.destinationsByIndex[index] = [];
            this.citiesByIndex[index] = [];
          }
        },
        error: (error: HttpErrorResponse) => {
          console.error('Error al cargar destinos:', error);
          this.destinationsByIndex[index] = [];
          this.citiesByIndex[index] = [];
        }
      });
    }

    // ✅ También para getDestinationsForIndex
    getDestinationsForIndex(index: number): DestinationData[] {
      return this.destinationsByIndex[index] || [];
    }

  getCities(destinationId: string, index: number) {

    if (!this.citiesByIndex[index]) {
        this.citiesByIndex[index] = [];
      }

    const business = this.bussinessNames.at(index) as FormGroup;
      business?.get('city_id')?.setValue(null);

    this._homeService.getCitiesData(destinationId).subscribe({
      next: (res: CityData[]) => {
        if (res && Array.isArray(res) && res.length > 0) {
           this.citiesByIndex[index] = res;
        } else {
          this.citiesByIndex[index] = [];
        }

      },
      error: (error: HttpErrorResponse) => {
        console.error(error);
        this.citiesByIndex[index] = [];
      }
    });
  }

  getCitiesForIndex(index: number): CityData[] {
  return this.citiesByIndex[index] || [];
}

  selectedCity(cityId: number, index: number): void {

    if(index !== 0) {
      return;
    }

    const cities: CityData[] = this.getCitiesForIndex(index) || [];

    if(cities && cities.length > 0) {

      const citySelected: CityData | null = cities.find(c => c.city_id === Number(cityId)) || null;

      if(citySelected) {

        this.providerForm.get('City')?.setValue(citySelected.city_id.toString());
        this.providerForm.get('city_name')?.setValue(citySelected.city_name);

      } else {
        console.warn('No se encontró la ciudad');
        return;
      }
    } else {
      console.warn('No se encontron las opciones de ciudades');
      return;
    }
  }



  getCategories() {
    this._signupService.categories().subscribe({
      next: (res: any) => {
        if(res && Array.isArray(res.data) && res.data.length > 0) {
            this.categories = res.data;
        } else {
          console.warn('Hubo un problema al cargar las categorías');
          this.categories = [];
        }

      },
      error: (error: HttpErrorResponse) => {
        console.error(error);
        this.categories = [];
      }
    });

    }

    get bussinessNames(): FormArray<BusinessNameFormGroup> {
    return this.providerForm.get('legal_entities') as FormArray<BusinessNameFormGroup>;
  }

  addBusinessName(): void {
    this.bussinessNames.push(this.createBusinessNameForm());
  }

  removeBusinessName(index: number): void {
    if (this.bussinessNames.length > 1) {
      this.bussinessNames.removeAt(index);
    }
  }


	async onSubmit() {

    if(this.providerForm.invalid) {
      this.providerForm.markAllAsTouched();
      return;
    };

    if(this.turnstileEnabled && !this.turnstileToken) {
      try {
        this.turnstileToken = await this.requestTurnstileToken();
      } catch (error) {
        this.notificationService.error('No se pudo completar la verificación de seguridad, intentá nuevamente.');
        return;
      }
    }

    const taxDocuments = this.bussinessNames.controls
      .map(business => business.get('tax_document_number')?.value)
      .filter((doc): doc is string => !!doc);

    const validations = taxDocuments.map(doc => this._signupService.validateTaxDocument(doc));

    forkJoin(validations).subscribe({
      next: (results: any[]) => {
        const alreadyRegistered = results.some(res => res && res.res === 1 && res.data && !res.data.available);

        if(alreadyRegistered) {
          this.notificationService.warning('El documento fiscal ingresado ya está registrado en nuestro sistema. Por favor, verifique la información y vuelva a intentarlo.');
          return;
        }

        this.submitProvider();
      },
      error: (error: HttpErrorResponse) => {
        console.error(error);
        this.notificationService.error('No se pudo validar el documento fiscal, intente nuevamente.');
      }
    });
	}

  private submitProvider(): void {
		// this.load = true; // loading screen
    const payload: any = this.providerForm.getRawValue();

    payload.legal_entity_template = this.getLegalEntitiesTemplate(payload);
    payload.turnstile_token = this.turnstileToken;


    		this._signupService.signup(payload).subscribe({
        next: (data: any) => {
          		this.load = false;
          		this.resetTurnstile();
          		if(data.res == 1) {
                this.resetform();
                this.successEvent.emit(); // Emitir el evento de éxito
                this.notificationService.success('Su solicitud de prerregistro fue enviada con éxito');
          		} else {

          		}
        },
        error: (error: HttpErrorResponse) => {
          this.load = false;
          this.resetTurnstile();

          // En joinus los errores del validador vienen en `men`, los del captcha en `msg`.
          const backendMsg = error.error?.msg as string | undefined;
          const backendDet = error.error?.det as string | undefined;

          if (backendMsg?.startsWith('CAPTCHA_')) {
            this.notificationService.warning(backendDet || 'Hubo un problema con la verificación de seguridad, intentá de nuevo.');
            return;
          }

          if(!this.buttonError) {
            this.buttonError = true;
            this.openModalErrorJoinUs.nativeElement.click();

            setTimeout(() => {
              this.closeButtonModalErrorSignup.nativeElement.click();
              this.errorEvent.emit();
            }, 1500);
          }
        }
      });
  }

  /** Los tokens de Turnstile son de un solo uso; hay que pedir uno nuevo tras cada intento de envío. */
  private resetTurnstile(): void {
    this.turnstileToken = null;
    this.turnstile?.reset();
  }

  /** Dispara el challenge (invisible salvo que Cloudflare necesite interacción) y espera el token. */
  private requestTurnstileToken(): Promise<string> {
    return new Promise((resolve, reject) => {
      this.turnstileResolve = resolve;
      this.turnstileReject = reject;
      this.turnstile?.execute();
    });
  }

  onTurnstileVerified(token: string): void {
    this.turnstileToken = token;
    this.turnstileResolve?.(token);
    this.turnstileResolve = null;
    this.turnstileReject = null;
  }

  onTurnstileExpired(): void {
    this.turnstileToken = null;
    this.turnstileReject?.(new Error('turnstile expired'));
    this.turnstileResolve = null;
    this.turnstileReject = null;
  }

  onTurnstileError(): void {
    this.turnstileToken = null;
    this.notificationService.error('No se pudo cargar la verificación de seguridad, recargue la página.');
    this.turnstileReject?.(new Error('turnstile error'));
    this.turnstileResolve = null;
    this.turnstileReject = null;
  }

  private getLegalEntitiesTemplate(values: any): any[] {

    let legalEntitiesTemplate: any[] = [];

    if(values.legal_entities.length === 0) {
      return [];
    }

    values.legal_entities.forEach((entity: any, index: number) => {


        const countryName = this.countries.find(c => c.country_code === entity.country_id)?.country_name || '';
        const destinationName = this.destinationsByIndex[index].find(c => Number(c.destination_id) === Number(entity.state_id))?.destination_name || '';
        const cityName  = this.citiesByIndex[index].find(c => Number(c.city_id) === Number(entity.city_id))?.city_name || '';
        const categoriesProvider: any[] = [];

        if(entity.category_ids && entity.category_ids.length > 0) {
          entity.category_ids.forEach((category: any) => {
            const categorySelected = this.categories.find(c => c.id === category);

            if(categorySelected) {
              categoriesProvider.push(
                {
                  id: category,
                  name: categorySelected.name
                }
              );
            }
          })
        }

        legalEntitiesTemplate.push({
          name: entity.name,
          document: entity.tax_document_number,
          address: entity.legal_address,
          country: countryName,
          state: destinationName,
          city: cityName,
          categories: categoriesProvider
        });

    });

    return legalEntitiesTemplate;
  }

	resetform(): void {

    this.countryName = '';

    this.providerForm.reset();


}

// ✅ Sanitizar entrada (eliminar caracteres peligrosos)
sanitizeInput(event: Event): void {
  const input = event.target as HTMLInputElement;
  // Eliminar caracteres peligrosos como < > & " '
  input.value = input.value.replace(/[<>"']/g, '');
}

// ✅ Bloquear teclas peligrosas
blockDangerousKeys(event: KeyboardEvent): void {
  const dangerousKeys = ['<', '>', '"', "'", '&', ';', '(', ')', '=', '%'];
  if (dangerousKeys.includes(event.key)) {
    event.preventDefault();
  }
}

     /**
   * Bloquea la entrada de caracteres no deseados (`e`, `E`, `+`, `-`) en campos numéricos.
   * @param event El evento de teclado.
   */
blockInvalidKeys(event: KeyboardEvent, input?: string) {
    const key = event.key;

    switch (input) {
        case 'name':
           const inputElementName = event.target as HTMLInputElement;
            const currentValueName = inputElementName.value || '';
            const selectionStartName = inputElementName.selectionStart ?? 0;

            // Permitir teclas de control
            if (['Backspace', 'Delete', 'Tab', 'Escape', 'Enter',
                'ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(key)) {
                return;
            }

            // Validar espacio
            if (key === ' ') {
                if (selectionStartName === 0) {
                    event.preventDefault();
                    return;
                }
                if (selectionStartName > 0 &&
                    currentValueName.charAt(selectionStartName - 1) === ' ') {
                    event.preventDefault();
                    return;
                }
                return;
            }

            // Solo letras (con acentos y ñ)
            if (!/^[a-zA-ZÀ-ÿ\u00f1\u00d1]$/.test(key)) {
                event.preventDefault();
            }
            break;

        case 'number':
            if (['e', 'E', '+', '-', ',', '.'].includes(key)) {
                event.preventDefault();
              }
            break;
    }
  }

}
